export default {
    company_avatar: 'Avatar kompanije',
    user_avatar: 'Avatar korisnika',
    top_companies: 'Top kompanije',
    reservation: 'Rezervacija',
    company_cover: 'Naslovna slika kompanije',
    offer_details: 'Detalji ponude',
    map_marker: 'Oznaka na mapi',
    offer_cover: 'Naslovna slika ponude',
    user_rating: 'Ocena korisnika',
    clock: 'Sat',
    rating_trophy: 'Trofej ocene',
    user_image: 'Slika korisnika',
    offer_image: 'Slika ponude',
}
